import styled, { keyframes } from 'styled-components/macro';

const Rotate = keyframes`
    from {
        rotate: 0deg;
    }
    to {
        rotate: 180deg;
    }
`;

const RotateReverse = keyframes`
    from {
        rotate: 180deg;
    }
    to {
        rotate: 0deg;
    }
`;

const getAnimation = (open: boolean) => {
  return open ? RotateReverse : Rotate;
};

export const StyledButton = styled.button`
  height: 24px;
  width: 24px;
  padding: 0;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;

  :disabled {
    display: none;
  }
`;

export const Wrapper = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  background-color: #f2f5f8;
  border-radius: 4px;
`;

export const Icon = styled.img<{ open: boolean }>`
  position: relative;
  left: 0;
  animation-name: ${(props) => getAnimation(props.open)};
  animation-delay: 0s;
  animation-duration: 350ms;
  rotate: ${(props) => (props.open ? '0deg' : '180deg')};
`;
